import { Box, Typography } from '@mui/material';
import useFetch from '../../../api/useFetch';
import { BillingPosition } from '../../../components/special/BillingPosition';
import Pagination from '../../../components/special/Pagination';
import { useState } from 'react';
import { NewBillingPosition } from '../../../components/new/NewBillingPosition';
import Loader from '../../../components/special/Loader';
import ExoDialog from '../../../components/exo/ExoDialog';
import { ProjectAddElementButton } from '../../../components/exo/project/ProjectAddElementButton';

import { useTranslation } from 'react-i18next';
import { updateOrCreate } from '../../../components/special/updateOrCreate';
import { API_POST, DBRequest, useConfig } from '../../../api/api';
import { ApplyProjectPreset } from '../ApplyProjectPreset';
import { PresetAddElementButton } from '../../../components/exo/project/PesetAddElementButton';

export const BillingPositionsTab = ({ project }) => {
  const config = useConfig();
  const { t } = useTranslation();
  const { apiData, setApiData } = useFetch(
    `project-positions?projectId[eq]=${project.id}`,
  );
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(null);

  // state for open apply preset dialog
  const [openPreset, setOpenPreset] = useState(false);

  function handlePosition(data) {
    handleCloseForm();
    setApiData(updateOrCreate(apiData, data.data));
  }

  function handleCloseForm() {
    setOpen(false);
    setEdit(null);
  }

  function handleDelete(element) {
    const newPositions = apiData.data.filter((obj) => obj.id !== element.id);
    setApiData({ ...apiData, data: newPositions });
  }

  function handleApplyPreset(data) {
    // need positions inside response to update the state
    DBRequest({
      config,
      path: `projects/${project.id}/apply-preset`,
      method: API_POST(data),
      onResponse: (res) =>
        setApiData((prev) => ({ ...prev, data: res.data.positions })),
    });
  }

  return (
    <Box className="flex flex-col justify-between gap-2 overflow-hidden w-full relative">
      <Loader active={isLoading || !apiData} />
      <Box className="flex flex-col gap-2 h-full overflow-y-auto w-full">
        <Typography className=" opacity-50 max-w-[600px]">
          {t(
            'Work packages can be billed via the billable positions. The time incurred or a flat rate amount can be invoiced via the position. Here, you can choose between a detailed, daily or a rough summary.',
          )}
        </Typography>
        {apiData?.data.map((pos) => (
          <BillingPosition key={pos.id} position={pos} onEdit={setEdit} />
        ))}
        {/* <ProjectAddElementButton onClick={() => setOpen(true)} size="small" /> */}
        <Box className="flex flex-row gap-2">
          <ProjectAddElementButton
            label={t('Add Billable Position')}
            onClick={() => setOpen(true)}
            size="small"
            className="backdrop-blur-lg basis-[70%] grow"
          />
          {/* button to ADD element from preset */}
          <PresetAddElementButton
            label={t('Add element from preset')}
            onClick={() => setOpenPreset(true)}
            size="small"
            className="backdrop-blur-lg basis-[30%] grow"
          />
        </Box>
      </Box>
      <Pagination
        data={apiData}
        setData={setApiData}
        setLoading={setIsLoading}
      />

      <ExoDialog
        open={open || Boolean(edit)}
        onClose={handleCloseForm}
        limitWidth
      >
        <NewBillingPosition
          projectId={project.id}
          onCreate={handlePosition}
          onUpdate={handlePosition}
          startData={edit}
          onClose={handleCloseForm}
          onDelete={handleDelete}
        />
      </ExoDialog>

      <ExoDialog
        open={openPreset}
        limitWidth
        onClose={() => setOpenPreset(false)}
      >
        <ApplyProjectPreset
          presetType="project"
          relations={['positions']}
          onApply={handleApplyPreset}
          onClose={() => setOpenPreset(false)}
        />
      </ExoDialog>
    </Box>
  );
};
